import { checkSameCoord } from "./checkSameCoord";
import GridArea from "../../../../../../../src/entities/GridArea";
import radianToDegree from "../../../../../../../src/utils/math/radianToDegree";
import { GRID_CONFIG } from "../../../types/Config";
import { PointAnswer, Question } from "../../../types/Interface";
import { Direction } from "../../../types/Enum";


export default function checkPointAnswer(question: Question, answer: PointAnswer): boolean {
  if (answer.answer.length !== 1) { return false }

  const qAns = GridArea.getGlobalCoord(GRID_CONFIG, question.pivotPoint);
  const trueRot = question.rotation;
  const trueDir = trueRot < 0 ? Direction.antiClockwise : Direction.clockwise;
  const secDir = trueRot < 0 ? Direction.clockwise : Direction.antiClockwise;
  const angle = Math.abs(radianToDegree(trueRot));
  const isSameCoord = checkSameCoord(qAns, answer.answer[0].coord[0]);


  if (isSameCoord && ((angle == answer.rotation && trueDir == answer.direction)
    || (angle == 360 - answer.rotation && secDir == answer.direction))) {
    return true;
  }
  return false;
}